import { SyntheticEvent } from 'react';
import {
  FetchAutocomplete,
  FetchAutocompleteChangeReason,
} from '@australiangreens/ag-internal-components';
import { AccordionField } from '@components/DrawerAccordion';
import { SUPPORTER_STATUSES_WITH_IDS } from '@/constants/filterCriteria/supporterStatus';
import { SupporterRecordResult } from '@/types/filterCriteriaRecords';

type SupporterStatusFormProps = {
  onChange: (
    newValue: SupporterRecordResult[],
    reason: FetchAutocompleteChangeReason,
    event: SyntheticEvent<Element, Event>
  ) => void;
  value: SupporterRecordResult[];
};

const SupporterStatusForm = ({ value, onChange }: SupporterStatusFormProps) => {
  return (
    <AccordionField>
      <FetchAutocomplete
        minLength={0}
        label="Find a Rocket status"
        preLoadedOptions={SUPPORTER_STATUSES_WITH_IDS}
        value={value}
        onChange={onChange}
        data-testid="supporterstatuses"
        loadingText="Looking for Rocket statuses..."
        noOptionsText="No Rocket statuses found"
      />
    </AccordionField>
  );
};

export default SupporterStatusForm;
